<script setup lang="ts">
import type { CentlexLemma } from "@/types/article-formats/centlex";

import ArticleFlexions from "./ArticleFlexions.vue";

const props = defineProps<{
  lemma: CentlexLemma;
}>();
</script>

<template>
  <div class="article-content__header article-header">
    <div class="article-header__content">
      <h5 class="article-header__word">{{ props.lemma.lemma }}</h5>
      <sup v-if="props.lemma.homonymId" class="article-header__sup">
        {{ props.lemma.homonymId }}
      </sup>

      <template v-if="props.lemma.flexions.length > 0">
        <span
          title="Ordklasse"
          class="article-header__element article-header__element--light article-header__element--italic"
        >
          {{ props.lemma.flexions[0].wordClasses }}
        </span>

        <ArticleFlexions :lemma="props.lemma.lemma" :flexions="props.lemma.flexions" />
      </template>
    </div>
  </div>
</template>
